import * as ActionTypes from "../action-types";
import {INACTIVE_SITES} from "../../config/constants";

const initialState = {
    sites: [],
    clients: [],
    clientsPagination: {},
    clientCosts: [],
    news: [],
    unreaded: false,
    purchases: {
        list: [],
        total: {},
        pagination: {}
    }
}

const Clients = (state= initialState,{type,payload = null}) => {
    switch(type){
        case ActionTypes.GET_CLIENTS:
            return getClients(state,payload);
        case ActionTypes.GET_SITES:
            return getSites(state,payload);
        case ActionTypes.ADD_PURCHASES:
            return addPurchases(state,payload);
        case ActionTypes.GET_NEWS:
            return getNews(state,payload);
        default:
            return state;
    }
};

const getClients = (state, payload) => {

    return {...state, clients: payload.list || [], clientsPagination: payload.pagination || {}};
}

const getSites = (state, payload) => {
    return {...state, sites: payload}
}

const getNews = (state, payload) => {
    let curDate = new Date();
    let unreaded = payload.filter((elem) => {
        let a = new Date(elem.publish_date).setDate(new Date(elem.publish_date).getDate() + 2);
        return a > curDate
    }).length
    return {...state, news: payload, unreaded}
}

const addPurchases = (state, payload) => {
    return {...state, purchases: payload};
}

export default Clients